export interface HomepageProductImage {
  imageUrl?: string | null;
  imageSource?: string | null;
}

export function hasVerifiedDailyMedImage(product: HomepageProductImage): boolean {
  return product.imageSource === "dailymed"
    && typeof product.imageUrl === "string"
    && product.imageUrl.trim().length > 0;
}